"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _head = _interopRequireDefault(require("next/head"));

var _locales = require("@meepshop/locales");

// import
require("./styles/error.less");

var styles = {
  "rotate": "meepshop-page-error__error__rotate",
  "move": "meepshop-page-error__error__move",
  "root": "meepshop-page-error__error__root",
  "image": "meepshop-page-error__error__image",
  "message": "meepshop-page-error__error__message",
  "errorId": "meepshop-page-error__error__errorId",
  "id": "meepshop-page-error__error__id"
}; // definition

var _default = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var title = _ref.title,
      loggerInfoId = _ref.loggerInfoId,
      children = _ref.children;

  var _useTranslation = (0, _locales.useTranslation)('apollo'),
      t = _useTranslation.t;

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_head["default"], null, /*#__PURE__*/_react["default"].createElement("title", null, title)), /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.root
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.image
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: require("@meepshop/images/lib/getImage")["default"]({
      stage: "https://img.meepstage.com/ekmQC-z0uQ3mKEa6tDH1KqEdfL6S2F7V90XorUz0YLg/Z3M6Ly9pbWcubWVlcGNsb3VkLmNvbS9hc3NldHMvcGFnZUVycm9yL3N0YXJzLnN2Zw.svg",
      production: "https://img.meepshop.com/Vrgs3viKSumbBjcoV2HpaBaWjPcbCYTYB_Fcyjiv82s/Z3M6Ly9pbWcubWVlcGNsb3VkLmNvbS9hc3NldHMvcGFnZUVycm9yL3N0YXJzLnN2Zw.svg"
    }),
    alt: "stars"
  }), /*#__PURE__*/_react["default"].createElement("img", {
    src: require("@meepshop/images/lib/getImage")["default"]({
      stage: "https://img.meepstage.com/1jqdJZg5rvRYr0SemtIYA7LXG29C0Frg71EOiOGUsro/Z3M6Ly9pbWcubWVlcGNsb3VkLmNvbS9hc3NldHMvcGFnZUVycm9yL3Ntb2tlLnN2Zw.svg",
      production: "https://img.meepshop.com/G-4p7mIXdmnfLMiiUSXnxjkMvEq2ilKYanLn9v77P5k/Z3M6Ly9pbWcubWVlcGNsb3VkLmNvbS9hc3NldHMvcGFnZUVycm9yL3Ntb2tlLnN2Zw.svg"
    }),
    alt: "smoke"
  }), /*#__PURE__*/_react["default"].createElement("img", {
    src: require("@meepshop/images/lib/getImage")["default"]({
      stage: "https://img.meepstage.com/fgPi0uPCoouA8b_MlUYNGWIqmt-FgizhXyVejFXLYkA/Z3M6Ly9pbWcubWVlcGNsb3VkLmNvbS9hc3NldHMvcGFnZUVycm9yL3NoaXAuc3Zn.svg",
      production: "https://img.meepshop.com/4nBjUk-960gMUIlHY71WNOpXLYUnI0l7f45PdRvVGxk/Z3M6Ly9pbWcubWVlcGNsb3VkLmNvbS9hc3NldHMvcGFnZUVycm9yL3NoaXAuc3Zn.svg"
    }),
    alt: "ship"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.message
  }, children, /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.errorId
  }, /*#__PURE__*/_react["default"].createElement("p", null, t('copy')), /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.id
  }, loggerInfoId)))));
});

exports["default"] = _default;